/**
 * jQuery plugin to wrap a custom jQueryUI accordion for use in the VIL
 * Holds the dst, as well as additional app specific panels if needed
 * Also manages the vertical expand-collapse 'accordion handler'
 *
 */

(function ($) {
  $.fn.customaccordion = function (vilInstance) {
    var self = this;

    var vil = vilInstance;

    if (vil == null || typeof vil === 'undefined') {
      $.error('VIL instance cannot be null');
    }

    var settings = vil.getConfiguration();

    var accordionOptions = {
      heightStyle: 'content',
      animate: 150
    };

    self.isInitialized = function () {
      if (settings) {
        return true;
      }

      return false;
    };

    /**
         * Brings the slide tray into the accordion
         * Looks for 'import' div - if present, loads dst into it; otherwise, appends dst div to accordion
         * TODO: Why is this here? Accordion widget should not have internal knowledge of external objects like VIL or DST -ccb
         * @returns {undefined}
         */
    self.importElements = function () {
      var accordion = vil.find('#' + settings.accordionSettings.divId);

      if (accordion.length == 1) {
        // Check if the import div is present in the view html (this will be the case for PR, for example)
        var dstImport = accordion.find('#' + settings.accordionSettings.divImportDst);
        if (dstImport.length == 0) {
          if (typeof window.__isAIH !== 'undefined' && window.__isAIH === true) {
            accordion.append('<h3>' + settings.dstSettings.dstTitle + '</h3>');
          }
          accordion.append("<div id='" + settings.dstSettings.divId + "' class='dst_container'></div>");
        } else {
          dstImport.append("<div id='" + settings.dstSettings.divId + "' class='dst_container'></div>");
        }
        self.refresh();
      }
    };

    /**
         * Append array of panels to accordion HTML
         * Array of panels in the form: [{id: '', title: 'title', html: '...', cssClass: 'class' }]
         * @returns {undefined}
         */
    self.appendPanels = function (panels) {
      var accordionDiv = vil.find('#' + settings.accordionSettings.divId);
      $.each(panels, function (index, panel) {
        accordionDiv
          .append($('<h3>').addClass(panel.cssClass).text(panel.title))
          .append($('<div>').attr('id', panel.id).addClass(panel.cssClass).html(panel.html));
      });
      self.refresh(); // rebuild the jQuery UI accordion
    };

    /**
         * Rebuild the jQuery UI accordion based on the underlying HTML.
         * @returns {undefined}
         */
    self.refresh = function () {
      // TODO: in jqueryui 1.10, .accordion('refresh') is suffcient to redraw after adding panels - no destroy needed
      var accordionDiv = vil.find('#' + settings.accordionSettings.divId);
      if (accordionDiv.length > 0) {
        if (accordionDiv.is(':ui-accordion')) {
          accordionDiv.accordion('destroy');
          accordionDiv.accordion(accordionOptions);
        }
      }
      // This is needed for case of popup with DST embedded in surrounding accordionContainer
      accordionDiv = vil.find('.dst_accordion');
      if (accordionDiv.length > 0) {
        if (accordionDiv.is(':ui-accordion')) {
          accordionDiv.accordion('refresh');
        }
      }
    };

    /**
         * Attach the needed elements to the accordion markup, then call initialize, which transforms it into jqueryUI widget
         * @returns {undefined}
         */
    self.renderAccordion = function () {
      var accordion = vil.find('#' + settings.accordionSettings.divId);
      if (accordion.length == 0) {
        if (settings.accordionSettings.divImport != null) {
          var importDivContent = $('#' + settings.accordionSettings.divImport);
          if (importDivContent.length == 0) {
            // arizzini we don't have an import div.
            var accordionAlreadyExists = $('#' + settings.accordionSettings.divId);
            if (accordionAlreadyExists.length == 0) {
              vil.append("<div id='" + settings.accordionSettings.divId + "' class='dstaccordion' style='width: 401px;' ></div>");
            } else {
              accordionAlreadyExists.css('width', 401);
              accordionAlreadyExists.appendTo(vil);
            }
          } else {
            // arizzini we have an import div.
            vil.append("<div id='" + settings.accordionSettings.divId + "' style='width: 401px;' ></div>");

            if (accordionAlreadyExists.length != 0) {
              accordionAlreadyExists.appendTo(vil);
            }
          }
        } else {
          vil.append("<div id='" + settings.accordionSettings.divId + "' style='width: auto;' ></div>");
        }
      }
      self.initializeAccordion();
    };

    /**
         * Given an accordion panel index, make it the active one
         * @param {type} activeIndex
         * @returns {undefined}
         */
    self.activatePanel = function (activeIndex) {
      if (settings.accordionSettings.divId != null) {
        vil.find('#' + settings.accordionSettings.divId).accordion({active: activeIndex});
      } else {
        vil.find('.dst_accordion').accordion({active: activeIndex});
      }
    };

    /**
         * Transform the accordion markup into a JQueryUI accordion widget
         * @returns {undefined}
         */
    self.initializeAccordion = function () {
      if (settings.accordionSettings.divImport != null || (typeof window.__isAIH !== 'undefined' && window.__isAIH)) {
        var accordionDiv = vil.find('#' + settings.accordionSettings.divId);
        if (accordionDiv.is(':ui-accordion')) {
          accordionDiv.accordion('destroy');
        }

        accordionDiv.accordion(accordionOptions);
      } else {
        accordionDiv = vil.find('.dst_accordion');
        if (accordionDiv.is(':ui-accordion')) {
          accordionDiv.accordion('destroy');
        }

        accordionDiv.accordion(
          {
            event: 'click hoverintent',
            autoHeight: true
          });
      }
    };

    // Attach jQuery Object Prototype (fn function)
    return self;
  };
})(jQuery);



// WEBPACK FOOTER //
// ./src/accordion/jquery.accordion.js